// LIQUID_GOLD: Rally Events Landing — FAQ accordion + scroll-reveal animations
window.LiquidGold = window.LiquidGold || {};

// FAQ accordion — only one item open at a time
window.LiquidGold.faqAccordion = {
  init() {
    document.querySelectorAll('.lg-ev-faq__item').forEach(item => {
      const question = item.querySelector('.lg-ev-faq__question');
      if (!question) return;
      question.addEventListener('click', () => {
        const wasOpen = item.classList.contains('lg-ev-faq__item--open');
        item.closest('.lg-ev-faq__list')
          .querySelectorAll('.lg-ev-faq__item')
          .forEach(i => i.classList.remove('lg-ev-faq__item--open'));
        if (!wasOpen) item.classList.add('lg-ev-faq__item--open');
      });
    });
  }
};

// Scroll-reveal via IntersectionObserver
window.LiquidGold.scrollReveal = {
  init() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const siblings = entry.target.parentElement.querySelectorAll('.lg-fu:not(.lg-fu--visible)');
          siblings.forEach((s, i) => setTimeout(() => s.classList.add('lg-fu--visible'), i * 80));
          entry.target.classList.add('lg-fu--visible');
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.lg-fu').forEach(el => observer.observe(el));
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.LiquidGold.faqAccordion.init();
  window.LiquidGold.scrollReveal.init();
});
